/* eslint-disable @typescript-eslint/no-explicit-any */
export const deepCopy = (obj: any) => JSON.parse(JSON.stringify(obj));
